import {Button} from '@startlibs/components'
import {Fill, useToggle} from '@startlibs/core';
import { useNavigate } from '@startlibs/components';
import React from 'react'
import {HeaderButtons, PageContainer, PageFooter} from '../components/PageLayout'
import {LogoutButton} from '../components/Navbar';
import {jwtGetFetcher} from '../utils/authFetch'
import {tryOrFail} from '../utils/utils'
import {PdfReportFrame} from '../request/components/PdfReportFrame'
import {PreviewForReport} from '../request/reviewedRequest/PreviewForReport'
import {wrapLazy} from "@startlibs/utils";

const lazyReport = wrapLazy((reportJWT) =>
  jwtGetFetcher(reportJWT)(`/api/report/json?nocache=${new Date().getTime()}`)
)

export const SharedReport = ({token}) => {
  const shareData = window.sessionStorage.getItem('sharedata')
  const navigate = useNavigate()
  const iframeIsLoading = useToggle(true)
  if (!shareData) {
    navigate('/share/'+token)
    return null
  }
  const {reportJWT} = tryOrFail(() => JSON.parse(shareData),() => navigate('/'))
  if (!reportJWT) {
    navigate('/share/'+token)
    return null
  }
  const {whenReturnedEpochMilli, report, info, caseLanguage} = lazyReport.use(reportJWT).read()
  const [firstName,lastName] = report.patientName.split(",")
  const patientInfo = {firstName,lastName}
  const exitAndInvalidateSession = () => { window.sessionStorage.clear(); navigate("/../../") }

  return <PageContainer noMarginOnPrint>
    <HeaderButtons className="hideOnPrint">
      <Button className="exit-shared" onClick={exitAndInvalidateSession}>Exit</Button>
      <div className="right-wrapper">
        <Button.a href={`/api/report/download?token=${reportJWT}`} icon="download" >Save PDF</Button.a>
        <Button.a target="_blank" href={`/api/report/preview?token=${reportJWT}`} highlight icon="print">Print</Button.a>
      </div>
    </HeaderButtons>
    {
      report.useCustomReport
      ? <PdfReportFrame
          pdfReport
          onLoad={iframeIsLoading.close}
          src={`/api/report/preview?token=${reportJWT}`}
        />
        : <PreviewForReport
          // preferredLanguage={report.preferredLanguage}
          preferredLanguage={caseLanguage}
          report={{...report,whenReturnedEpochMilli,patientInfo}}
          info={{...info,...info.address}}
        />
    }

    <PageFooter className="hideOnPrint reviewed-footer">
      <Button onClick={() => navigate("/../../")}>Exit</Button>
      <div className="right-wrapper">
        <Button.a href={`/api/report/download?token=${reportJWT}`}  icon="download">Save PDF</Button.a>
        <Button.a target="_blank" href={`/api/report/preview?token=${reportJWT}`}  highlight icon="print">Print</Button.a>
      </div>
    </PageFooter>
    <Fill name="Navbar-Exit">
      <LogoutButton onClick={exitAndInvalidateSession} >Exit</LogoutButton>
    </Fill>
  </PageContainer>
}
